import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import useSlabVsMember from "./useSlabVsMember";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SlabVsMember = (props) => {
  const { graphData } = useSlabVsMember(props);

  // Filter and process valid data
  const validData = graphData.filter(
    (item) => item.slab && !isNaN(parseInt(item.totalmember, 10))
  );

  // Get the maximum value to determine the scale
  const maxValue = Math.max(...validData.map((item) => parseInt(item.totalmember, 10)));

  // Determine the scale unit based on maxValue
  let scaleStep = 1; // Default
  if (maxValue > 100 && maxValue <= 1000) scaleStep = 100;
  else if (maxValue > 1000 && maxValue <= 10000) scaleStep = 1000;
  else if (maxValue > 10000 && maxValue <= 50000) scaleStep = 5000;
  else if (maxValue > 50000) scaleStep = 50000;

  // Prepare data for the chart
  const data = {
    labels: validData.map((item) => item.slab),
    datasets: [
      {
        label: "Members",
        data: validData.map((item) => parseInt(item.totalmember, 10)),
        backgroundColor: "rgba(75, 192, 192, 0.5)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Slab vs Members",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.raw.toLocaleString()}`; // Show raw numbers
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Tier Slabs",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: `Members (scaled by ${scaleStep})`,
        },
        ticks: {
          stepSize: scaleStep,
          callback: function (value) {
            return value.toLocaleString(); // Format tick labels
          },
        },
        max: Math.ceil(maxValue / scaleStep) * scaleStep, // Scale max to the next step
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default SlabVsMember;
